(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('best-sellers')) {
    customElements.define(
      'best-sellers',
      class extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;

          this.stage = this.querySelector('.bs-stage');
          this.items = Array.from(this.querySelectorAll('.bs-item'));
          this.dots = Array.from(this.querySelectorAll('.bs-dot'));
          this.n = this.items.length;
          if (!this.n) return;

          this.active = this.dataset.startMiddle === 'true' ? Math.floor((this.n - 1) / 2) : 0;
          this.prevOffsets = new Array(this.n).fill(null);
          this.mq = window.matchMedia('(min-width: 750px)');

          const prev = this.querySelector('.bs-arrow--prev');
          const next = this.querySelector('.bs-arrow--next');
          if (prev) prev.addEventListener('click', () => this.go(this.active - 1));
          if (next) next.addEventListener('click', () => this.go(this.active + 1));
          this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.go, 10))));

          // Clicking a side product brings it to the centre instead of opening it
          this.items.forEach((el, i) => {
            el.addEventListener('click', (e) => {
              if (this._dragged) {
                e.preventDefault();
                return;
              }
              if (i !== this.active) {
                e.preventDefault();
                this.go(i);
              }
            });
          });

          // Swipe / drag
          this.stage.addEventListener('pointerdown', (e) => {
            this._startX = e.clientX;
            this._startY = e.clientY;
            this._dragged = false;
          });
          this.stage.addEventListener('pointerup', (e) => {
            if (this._startX == null) return;
            const dx = e.clientX - this._startX;
            const dy = e.clientY - this._startY;
            this._startX = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              this._dragged = true;
              this.go(this.active + (dx < 0 ? 1 : -1));
              setTimeout(() => (this._dragged = false), 50);
            }
          });
          this.stage.addEventListener('pointercancel', () => (this._startX = null));

          // Keyboard
          this.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.active - 1); }
            if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.active + 1); }
          });

          // Autoplay (pauses on hover / focus / hidden tab)
          if (this.dataset.autoplay === 'true' && this.n > 1) {
            const ms = (parseFloat(this.dataset.speed) || 4) * 1000;
            this._paused = false;
            this.addEventListener('mouseenter', () => (this._paused = true));
            this.addEventListener('mouseleave', () => (this._paused = false));
            this.addEventListener('focusin', () => (this._paused = true));
            this.addEventListener('focusout', () => (this._paused = false));
            this._timer = setInterval(() => {
              if (!this._paused && !document.hidden) this.go(this.active + 1);
            }, ms);
          }

          this._ro = new ResizeObserver(() => this.layout());
          this._ro.observe(this.stage);
          this.layout();
        }

        disconnectedCallback() {
          if (this._timer) clearInterval(this._timer);
          if (this._ro) this._ro.disconnect();
        }

        visibleCount() {
          const v = parseInt(this.mq.matches ? this.dataset.visible : this.dataset.visibleMobile, 10) || 3;
          return Math.max(1, Math.min(v, this.n % 2 === 0 ? this.n - 1 : this.n));
        }

        layout() {
          const w = this.stage.clientWidth;
          if (!w) return;
          const v = this.visibleCount();
          if (w === this._lastW && v === this._lastV) return;
          this._lastW = w;
          this._lastV = v;
          this.half = Math.floor(v / 2);
          this.style.setProperty('--bs-gap', w / v + 'px');
          this.render(true);
        }

        offsetOf(i) {
          const n = this.n;
          let o = (((i - this.active) % n) + n) % n;
          if (o > n / 2) o -= n;
          return o;
        }

        go(i) {
          this.active = ((i % this.n) + this.n) % this.n;
          this.render(false);
        }

        render(instant) {
          const jumpers = [];
          this.items.forEach((el, i) => {
            const o = this.offsetOf(i);
            const prev = this.prevOffsets[i];
            const visible = Math.abs(o) <= this.half;
            const wraps = prev !== null && Math.abs(o - prev) > 1;

            el.style.zIndex = String(100 - Math.abs(o));
            el.classList.toggle('is-active', o === 0);
            el.setAttribute('aria-hidden', visible ? 'false' : 'true');
            el.style.pointerEvents = visible ? '' : 'none';
            el.querySelectorAll('a, button').forEach((a) => a.setAttribute('tabindex', visible ? '0' : '-1'));

            if (instant || wraps) {
              // Jump to the other end without sliding across, then fade in
              el.style.transition = 'none';
              if (wraps && !instant) el.style.opacity = '0';
              el.style.setProperty('--o', o);
              if (instant) el.style.opacity = visible ? '1' : '0';
              else jumpers.push([el, visible]);
            } else {
              el.style.transition = '';
              el.style.setProperty('--o', o);
              el.style.opacity = visible ? '1' : '0';
            }
            this.prevOffsets[i] = o;
          });

          if (jumpers.length || instant) {
            void this.stage.offsetWidth;
            requestAnimationFrame(() => {
              this.items.forEach((el) => (el.style.transition = ''));
              jumpers.forEach(([el, visible]) => (el.style.opacity = visible ? '1' : '0'));
            });
          }

          this.dots.forEach((d, i) => {
            d.classList.toggle('is-active', i === this.active);
            d.setAttribute('aria-current', i === this.active ? 'true' : 'false');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-grid-slider')) {
    customElements.define(
      'collection-grid-slider',
      class extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;
          this.track = this.querySelector('.cgs-track');
          this.cards = Array.from(this.querySelectorAll('.cgs-card'));
          this.dotsWrap = this.querySelector('.cgs-dots');
          this.prev = this.querySelector('.cgs-arrow--prev');
          this.next = this.querySelector('.cgs-arrow--next');
          if (!this.track || !this.cards.length) return;

          if (this.dotsWrap) {
            this.cards.forEach((_, i) => {
              const d = document.createElement('button');
              d.type = 'button';
              d.className = 'cgs-dot';
              d.setAttribute('aria-label', 'Go to product ' + (i + 1));
              d.addEventListener('click', () => this.goTo(i));
              this.dotsWrap.appendChild(d);
            });
            this.dots = Array.from(this.dotsWrap.children);
          }
          if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.current() - 1));
          if (this.next) this.next.addEventListener('click', () => this.goTo(this.current() + 1));

          let t;
          this.track.addEventListener('scroll', () => {
            cancelAnimationFrame(t);
            t = requestAnimationFrame(() => this.update());
          }, { passive: true });
          window.addEventListener('resize', () => this.update());
          this.update();
        }

        step() {
          if (this.cards.length < 2) return this.track.clientWidth;
          return this.cards[1].offsetLeft - this.cards[0].offsetLeft;
        }

        current() {
          const st = this.step() || 1;
          return Math.round(this.track.scrollLeft / st);
        }

        goTo(i) {
          const idx = Math.max(0, Math.min(i, this.cards.length - 1));
          this.track.scrollTo({ left: idx * this.step(), behavior: 'smooth' });
        }

        update() {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          let idx = this.current();
          if (this.track.scrollLeft >= maxScroll - 4) idx = this.cards.length - 1;
          if (this.dots) this.dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
          if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
          if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll - 4;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-product-slider')) {
    customElements.define(
      'featured-product-slider',
      class extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;

          this.stage = this.querySelector('.fps-stage');
          this.items = Array.from(this.querySelectorAll('.fps-item'));
          this.n = this.items.length;
          this.caption = this.querySelector('.fps-caption');
          this.nameEl = this.querySelector('.fps-name');
          this.ratingEl = this.querySelector('.fps-rating');
          this.reviewsEl = this.querySelector('.fps-reviews');
          this.btnEl = this.querySelector('.fps-btn');
          if (!this.n) return;

          this.active = this.dataset.startMiddle === 'true' ? Math.floor((this.n - 1) / 2) : 0;
          this.prevOffsets = new Array(this.n).fill(null);
          this.mq = window.matchMedia('(min-width: 750px)');

          const prev = this.querySelector('.fps-arrow--prev');
          const next = this.querySelector('.fps-arrow--next');
          if (prev) prev.addEventListener('click', () => this.go(this.active - 1));
          if (next) next.addEventListener('click', () => this.go(this.active + 1));

          // Click a side product to bring it to the centre; click the centre one to open it
          this.items.forEach((el, i) => {
            el.addEventListener('click', (e) => {
              if (this._dragged) { e.preventDefault(); return; }
              if (i !== this.active) { e.preventDefault(); this.go(i); }
              else if (!el.dataset.url) e.preventDefault();
            });
            el.addEventListener('shopify:block:select', () => this.go(i));
          });

          // Swipe / drag
          this.stage.addEventListener('pointerdown', (e) => {
            this._sx = e.clientX;
            this._sy = e.clientY;
            this._dragged = false;
          });
          this.stage.addEventListener('pointerup', (e) => {
            if (this._sx == null) return;
            const dx = e.clientX - this._sx;
            const dy = e.clientY - this._sy;
            this._sx = null;
            if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
              this._dragged = true;
              this.go(this.active + (dx < 0 ? 1 : -1));
              setTimeout(() => (this._dragged = false), 60);
            }
          });
          this.stage.addEventListener('pointercancel', () => (this._sx = null));

          this.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.active - 1); }
            if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.active + 1); }
          });

          if (this.dataset.autoplay === 'true' && this.n > 1) {
            const ms = (parseFloat(this.dataset.speed) || 4) * 1000;
            this._paused = false;
            this.addEventListener('mouseenter', () => (this._paused = true));
            this.addEventListener('mouseleave', () => (this._paused = false));
            this.addEventListener('focusin', () => (this._paused = true));
            this.addEventListener('focusout', () => (this._paused = false));
            this._timer = setInterval(() => {
              if (!this._paused && !document.hidden) this.go(this.active + 1);
            }, ms);
          }

          this._ro = new ResizeObserver(() => this.layout());
          this._ro.observe(this.stage);
          this.layout();
        }

        disconnectedCallback() {
          clearInterval(this._timer);
          if (this._ro) this._ro.disconnect();
        }

        layout() {
          const w = this.stage.clientWidth;
          if (!w) return;
          const desktop = this.mq.matches;
          const key = w + (desktop ? 'd' : 'm');
          if (key === this._lastKey) return;
          this._lastKey = key;

          let gap, item;
          if (desktop) {
            // Evenly spaced row: 3, 5 or 7 slots
            const maxV = this.n % 2 === 0 ? this.n - 1 : this.n;
            const v = Math.max(1, Math.min(parseInt(this.dataset.visible, 10) || 5, maxV));
            gap = w / v;
            item = gap * 0.9;
            this.half = Math.floor(v / 2);
          } else {
            // Mobile: big centre product, neighbours peek in from the edges
            const mw = parseFloat(this.dataset.mobileWidth) || 0.55;
            const peek = parseFloat(this.dataset.peek) || 0.06;
            item = w * mw;
            // neighbour centres sit `peek` of the width in from each edge
            gap = w * (0.5 - peek);
            this.half = 1;
          }
          this.style.setProperty('--fps-gap', gap + 'px');
          this.style.setProperty('--fps-item', item + 'px');
          this.render(true);
        }

        offsetOf(i) {
          const n = this.n;
          let o = (((i - this.active) % n) + n) % n;
          if (o > n / 2) o -= n;
          return o;
        }

        go(i) {
          this.active = ((i % this.n) + this.n) % this.n;
          this.render(false);
        }

        render(instant) {
          const jumpers = [];
          this.items.forEach((el, i) => {
            const o = this.offsetOf(i);
            const prev = this.prevOffsets[i];
            const visible = Math.abs(o) <= this.half;
            const wraps = prev !== null && Math.abs(o - prev) > 1;

            el.style.zIndex = String(100 - Math.abs(o));
            el.classList.toggle('is-active', o === 0);
            el.setAttribute('tabindex', visible ? '0' : '-1');
            el.setAttribute('aria-hidden', visible ? 'false' : 'true');
            el.style.pointerEvents = visible ? '' : 'none';

            if (instant || wraps) {
              el.style.transition = 'none';
              if (wraps && !instant) el.style.opacity = '0';
              el.style.setProperty('--o', o);
              if (instant) el.style.opacity = visible ? '1' : '0';
              else jumpers.push([el, visible]);
            } else {
              el.style.transition = '';
              el.style.setProperty('--o', o);
              el.style.opacity = visible ? '1' : '0';
            }
            this.prevOffsets[i] = o;
          });

          void this.stage.offsetWidth;
          requestAnimationFrame(() => {
            this.items.forEach((el) => (el.style.transition = ''));
            jumpers.forEach(([el, visible]) => (el.style.opacity = visible ? '1' : '0'));
          });

          this.updateCaption(instant);
        }

        updateCaption(instant) {
          const el = this.items[this.active];
          const apply = () => {
            const url = el.dataset.url || '';
            if (this.nameEl) {
              this.nameEl.textContent = el.dataset.title || '';
              if (url) this.nameEl.setAttribute('href', url);
              else this.nameEl.removeAttribute('href');
            }
            if (this.btnEl) {
              if (url) this.btnEl.setAttribute('href', url);
              else this.btnEl.removeAttribute('href');
            }
            if (this.ratingEl) {
              const r = parseFloat(el.dataset.rating) || 0;
              const c = parseInt(el.dataset.count, 10) || 0;
              this.ratingEl.hidden = r <= 0;
              this.ratingEl.style.setProperty('--fps-rating', Math.min(r / 5, 1) * 100 + '%');
              this.ratingEl.setAttribute('aria-label', r + ' out of 5 stars');
              if (this.reviewsEl) this.reviewsEl.textContent = c > 0 ? c + (c === 1 ? ' review' : ' reviews') : '';
            }
          };
          if (instant || !this.caption) { apply(); return; }
          this.caption.classList.add('is-fading');
          clearTimeout(this._capT);
          this._capT = setTimeout(() => {
            apply();
            this.caption.classList.remove('is-fading');
          }, 220);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-banner')) {
    customElements.define(
      'hero-banner',
      class extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;

          this.track = this.querySelector('.hb-track');
          this.slides = Array.from(this.querySelectorAll('.hb-slide'));
          this.dots = Array.from(this.querySelectorAll('.hb-dot'));
          this.n = this.slides.length;
          this.index = 0;
          this.isFade = this.classList.contains('hb--fade');
          if (this.n < 2) return;

          const prev = this.querySelector('.hb-arrow--prev');
          const next = this.querySelector('.hb-arrow--next');
          if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
          if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
          this.dots.forEach((d) =>
            d.addEventListener('click', () => { this.go(parseInt(d.dataset.go, 10)); this.restart(); })
          );

          // Swipe / drag
          const vp = this.querySelector('.hb-viewport');
          vp.addEventListener('pointerdown', (e) => {
            this._sx = e.clientX;
            this._sy = e.clientY;
            this._dragged = false;
          });
          vp.addEventListener('pointerup', (e) => {
            if (this._sx == null) return;
            const dx = e.clientX - this._sx;
            const dy = e.clientY - this._sy;
            this._sx = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              this._dragged = true;
              this.go(this.index + (dx < 0 ? 1 : -1));
              this.restart();
            }
          });
          vp.addEventListener('pointercancel', () => (this._sx = null));
          // Don't open the slide link after a swipe
          vp.addEventListener('click', (e) => {
            if (this._dragged) {
              e.preventDefault();
              this._dragged = false;
            }
          }, true);

          // Keyboard
          this.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') { this.go(this.index - 1); this.restart(); }
            if (e.key === 'ArrowRight') { this.go(this.index + 1); this.restart(); }
          });

          // Autoplay: pauses on hover, keyboard focus, and when the tab is hidden
          this.autoplay = this.dataset.autoplay === 'true';
          this.ms = (parseFloat(this.dataset.interval) || 5) * 1000;
          this._hover = false;
          this.addEventListener('mouseenter', () => (this._hover = true));
          this.addEventListener('mouseleave', () => (this._hover = false));
          this.addEventListener('focusin', () => (this._hover = true));
          this.addEventListener('focusout', () => (this._hover = false));
          this.restart();

          // Theme editor: jump to the slide being edited
          this.slides.forEach((slide, i) => {
            slide.addEventListener('shopify:block:select', () => {
              this._editing = true;
              this.go(i);
            });
            slide.addEventListener('shopify:block:deselect', () => {
              this._editing = false;
            });
          });

          this.render();
        }

        disconnectedCallback() {
          clearInterval(this._timer);
        }

        restart() {
          clearInterval(this._timer);
          if (!this.autoplay) return;
          this._timer = setInterval(() => {
            if (this._hover || this._editing || document.hidden) return;
            this.go(this.index + 1);
          }, this.ms);
        }

        go(i) {
          this.index = ((i % this.n) + this.n) % this.n;
          this.render();
        }

        render() {
          if (!this.isFade) {
            this.track.style.transform = 'translateX(' + -this.index * 100 + '%)';
          }
          this.slides.forEach((s, i) => {
            const on = i === this.index;
            s.classList.toggle('is-active', on);
            s.setAttribute('aria-hidden', on ? 'false' : 'true');
            s.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', on ? '0' : '-1'));
          });
          this.dots.forEach((d, i) => {
            d.classList.toggle('is-active', i === this.index);
            d.setAttribute('aria-current', i === this.index ? 'true' : 'false');
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-compare')) {
    customElements.define(
      'image-compare',
      class extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.range = this.querySelector('.ic-range');
          this.dragging = false;

          this.update(parseFloat(this.dataset.start) || 50);

          this.addEventListener('pointerdown', this.onDown);
          this.addEventListener('pointermove', this.onMove);
          this.addEventListener('pointerup', this.onUp);
          this.addEventListener('pointercancel', this.onUp);
          if (this.range) {
            this.range.addEventListener('input', () => {
              this.classList.add('has-moved');
              this.update(this.range.value);
            });
          }

          if (this.dataset.nudge === 'true') this.setupNudge();
        }

        setupNudge() {
          const start = parseFloat(this.dataset.start) || 50;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce || !('IntersectionObserver' in window)) return;
          const io = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            if (this.classList.contains('has-moved')) return;
            this.classList.add('is-nudging');
            const steps = [start - 12, start + 12, start];
            steps.forEach((v, i) => {
              setTimeout(() => {
                if (this.dragging || this.classList.contains('has-moved')) return;
                this.update(v);
              }, 400 + i * 650);
            });
            setTimeout(() => this.classList.remove('is-nudging'), 400 + steps.length * 650 + 100);
          }, { threshold: 0.5 });
          io.observe(this);
        }

        update(value) {
          const pos = Math.min(100, Math.max(0, parseFloat(value)));
          this.style.setProperty('--ic-pos', pos + '%');
          if (this.range && this.range.value != pos) this.range.value = pos;
        }

        fromEvent(e) {
          const rect = this.getBoundingClientRect();
          this.update(((e.clientX - rect.left) / rect.width) * 100);
        }

        onDown = (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          this.dragging = true;
          this.classList.remove('is-nudging');
          this.classList.add('is-dragging', 'has-moved');
          this.setPointerCapture(e.pointerId);
          // On touch, wait for movement so a vertical scroll doesn't jump the slider
          if (e.pointerType !== 'touch') this.fromEvent(e);
        };

        onMove = (e) => {
          if (!this.dragging) return;
          this.fromEvent(e);
        };

        onUp = (e) => {
          this.dragging = false;
          this.classList.remove('is-dragging');
          if (this.hasPointerCapture(e.pointerId)) this.releasePointerCapture(e.pointerId);
        };
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-rotator')) {
    customElements.define(
      'announcement-rotator',
      class extends HTMLElement {
        connectedCallback() {
          this.msgs = Array.from(this.querySelectorAll('.ab-msg'));
          if (this.msgs.length < 2) return;
          this.index = Math.max(0, this.msgs.findIndex((m) => m.classList.contains('is-active')));
          const ms = (parseFloat(this.dataset.interval) || 4) * 1000;
          this._paused = false;
          this.addEventListener('mouseenter', () => (this._paused = true));
          this.addEventListener('mouseleave', () => (this._paused = false));
          this.addEventListener('focusin', () => (this._paused = true));
          this.addEventListener('focusout', () => (this._paused = false));
          clearInterval(this._timer);
          this._timer = setInterval(() => {
            if (this._paused || document.hidden) return;
            this.next();
          }, ms);
        }

        disconnectedCallback() {
          clearInterval(this._timer);
        }

        next() {
          const current = this.msgs[this.index];
          this.index = (this.index + 1) % this.msgs.length;
          const upcoming = this.msgs[this.index];

          current.classList.remove('is-active');
          current.classList.add('is-leaving');
          // start the incoming message from below
          upcoming.classList.remove('is-leaving');
          void upcoming.offsetWidth;
          upcoming.classList.add('is-active');
          setTimeout(() => current.classList.remove('is-leaving'), 500);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
